// @ts-check

/**
 * @returns {React.ReactElement}
 */
export default function EyeIcon() {
  return (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.01677 7.59432C0.90328 7.41462 0.846535 7.32477 0.81477 7.18618C0.79091 7.08209 0.79091 6.91792 0.81477 6.81383C0.846535 6.67524 0.90328 6.58539 1.01677 6.40569C1.95461 4.92071 4.74617 1.16667 9.00034 1.16667C13.2545 1.16667 16.0461 4.92071 16.9839 6.40569C17.0974 6.58539 17.1541 6.67524 17.1859 6.81383C17.2098 6.91792 17.2098 7.08209 17.1859 7.18618C17.1541 7.32477 17.0974 7.41462 16.9839 7.59432C16.0461 9.0793 13.2545 12.8333 9.00034 12.8333C4.74617 12.8333 1.95461 9.0793 1.01677 7.59432Z"
        stroke="#262626"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.00034 9.5C10.381 9.5 11.5003 8.38072 11.5003 7C11.5003 5.61929 10.381 4.50001 9.00034 4.50001C7.61962 4.50001 6.50034 5.61929 6.50034 7C6.50034 8.38072 7.61962 9.5 9.00034 9.5Z"
        stroke="#262626"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  )
}
